import { inject, Injectable } from '@angular/core';
import { FileParser } from './file-parser.interface';
import { CsvFileParserService } from './csv-file-parser.service';
import { XlsxFileParserService } from './xlsx-file-parser.service';

@Injectable({
  providedIn: 'root',
})
export class FileParserFactoryService {
  private readonly csvParser = inject(CsvFileParserService);
  private readonly xlsxParser = inject(XlsxFileParserService);

  private readonly parsers: FileParser[];

  constructor() {
    this.parsers = [this.csvParser, this.xlsxParser];
  }

  getParser(file: File): FileParser {
    const parser = this.parsers.find((p) => p.canParse(file));
    if (!parser) {
      const extension = file.name.split('.').pop()?.toLowerCase() || 'unknown';
      throw new Error(`Unsupported file type: .${extension}`);
    }
    return parser;
  }

  canParse(file: File): boolean {
    return this.parsers.some((p) => p.canParse(file));
  }

  getSupportedExtensions(): string[] {
    return ['csv', 'xls', 'xlsx', 'xlsm', 'xlsb'];
  }
}
